import { LandlineIcon } from '@rsos/assets/icons';
import { Button } from '@rsos/base-components';
import IntlCallbackModal from './IntlCallbackModal';
import styles from './OverviewIntlCallbackCard.module.css';
import useIntlCallback from './useIntlCallback';

/**
 * Overview-tab card for the International Callback feature. Displays a
 * brief description and a Request button that opens the callback modal.
 */
const OverviewIntlCallbackCard = () => {
  const { state, open, close } = useIntlCallback();

  return (
    <>
      <div className={styles.card} data-name="overview-intl-callback-card">
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.titleRow}>
              <LandlineIcon
                aria-hidden
                color="primaryText"
                height={12}
                width={12}
              />
              <span
                className={styles.title}
                data-name="overview-intl-callback-card-title"
              >
                Intl. Callback
              </span>
            </div>
            <span
              className={styles.subtitle}
              data-name="overview-intl-callback-card-subtitle"
            >
              International Numbers
            </span>
          </div>
          <p
            className={styles.description}
            data-name="overview-intl-callback-card-description"
          >
            Start a bridge to call back international numbers.
          </p>
        </div>
        <Button
          btnType="tertiary"
          dataName="overview-intl-callback-card-button"
          grow
          noMargin
          onClick={open}
        >
          <span className={styles.buttonLabel}>Start the call</span>
        </Button>
      </div>
      <IntlCallbackModal
        isOpened={state.isOpen}
        onClose={close}
        onRetry={open}
        pin={state.pin}
        bridgeNumber={state.bridgeNumber}
        callerPhoneNumber={state.callerPhoneNumber}
        isCreatingSession={state.isCreatingSession}
        error={state.error}
      />
    </>
  );
};

export default OverviewIntlCallbackCard;
